import { Grid, IconButton, Typography } from '@mui/material';
import { memo, useState } from 'react';

import { CriteriaData } from '../../../../../../../../../api/theHive/criteriaGroups/types';
import { IconDeleteMS } from '../../../../../../../../../constants/icons';
import { AccordionCriteria } from './AccordionCriteria';

interface CriteriaItemProps {
  criteriaId: number;
  defaultCriteriasData: CriteriaData[];
  onDeleteCriteria: (criteriaId: number) => void;
}

const CriteriaItem = memo(
  ({
    criteriaId,
    defaultCriteriasData,
    onDeleteCriteria,
  }: CriteriaItemProps) => {
    const [expanded, setExpanded] = useState(false);

    const criteriaData = defaultCriteriasData.find(
      (criteria) => criteria.id === criteriaId
    );
    const findIndex = defaultCriteriasData.findIndex(
      (item) => item.id === criteriaId
    );

    return (
      <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
        <Grid item>
          <IconButton
            onClick={() => criteriaData && onDeleteCriteria(criteriaData.id)}
            sx={(theme) => ({
              color: '#707070',
              '&:hover': {
                color: theme.palette.secondary.main,
              },
            })}
          >
            {IconDeleteMS}
          </IconButton>
        </Grid>
        <Grid item>
          <AccordionCriteria
            title={`Critério ${findIndex + 1}`}
            openAccordion={expanded}
            setOpenAccordion={setExpanded}
          />
        </Grid>
        {expanded && (
          <Grid item xs={12}>
            <Typography sx={{ ml: 2, mb: 2 }}>
              {criteriaData?.description}
            </Typography>
          </Grid>
        )}
      </Grid>
    );
  }
);

export default CriteriaItem;
